import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { supabase } from "./supabaseClient";
import Login from "./screens/Login";
import Dashboard from "./screens/Dashboard";
import BibliotecaDigitalaPage from "./screens/BibliotecaDigitala";
import PunctePage from "./screens/Puncte";
import CotizatiiPage from "./screens/Cotizatii";
import SettingsPage from "./screens/Setari";
import ChangePasswordPage from "./screens/SchimbareParola";
import "./index.css";
import CreareProiect from "./screens/CreareProiect";
import ProiecteAprobate from "./screens/Proiecte";

function ProtectedRoute({ children }) {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [memberData, setMemberData] = useState(null);
  const [memberLoading, setMemberLoading] = useState(true);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session?.user) {
        setUser(session.user);
      }
      setLoading(false);
    });
    const { data: listener } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
      setLoading(false);
    });
    return () => {
      listener?.subscription.unsubscribe();
    };
  }, []);

  useEffect(() => {
    if (!user) return;

    setMemberLoading(true);
    async function fetchMember() {
      try {
        const res = await fetch(
          `https://prdp-api.suport-949.workers.dev/api/membru-meu?user_id_supabase=${user.id}`,
          {
            headers: {
              Authorization: "Bearer unwantedtok",
            },
          }
        );
        if (!res.ok) {
          console.error("Eroare la preluarea datelor membrului");
          setMemberData(null);
          setMemberLoading(false);
          return;
        }
        const data = await res.json();
        setMemberData(data);
        setMemberLoading(false);
      } catch (error) {
        console.error("Fetch error:", error);
        setMemberData(null);
        setMemberLoading(false);
      }
    }
    fetchMember();
  }, [user]);

  if (loading || memberLoading) {
    return <div>Se încarcă...</div>;
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  if (!memberData) {
    return <div>Eroare: nu s-au putut încărca datele membrului.</div>;
  }

  return React.cloneElement(children, { memberData });
}



function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/puncte"
          element={
            <ProtectedRoute>
              <PunctePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/cotizatii"
          element={
            <ProtectedRoute>
              <CotizatiiPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/biblioteca-digitala"
          element={
            <ProtectedRoute>
              <BibliotecaDigitalaPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/propune-proiect"
          element={
            <ProtectedRoute>
              <CreareProiect />
            </ProtectedRoute>
          }
        />
        <Route
          path="/proiecte"
          element={
            <ProtectedRoute>
              <ProiecteAprobate />
            </ProtectedRoute>
          }
        />
        <Route
          path="/setari"
          element={
            <ProtectedRoute>
              <SettingsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/schimbare-parola"
          element={
            <ProtectedRoute>
              <ChangePasswordPage />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
